
    (() => {
      const DRAWER_SELECTOR = 'filters-dialog#filters';
      const BODY_CLASS = 'filters-sidebar-open';
      const DESKTOP_QUERY = '(min-width: 992px)';

      function isDesktop() {
        return window.matchMedia(DESKTOP_QUERY).matches;
      }

      // Desktop shows the filters as a sidebar beside the products.
      // Opening them as a modal traps focus and locks scrolling, which
      // steals clicks from the pagination links below the grid.
      function prepareDesktopSidebar(drawer) {
        if (isDesktop()) {
          drawer.setAttribute('data-a11y-dialog-no-focus-trap', '');
          return;
        }

        drawer.removeAttribute('data-a11y-dialog-no-focus-trap');
      }

      function unlockPageScroll() {
        if (!isDesktop()) return;
        document.body.classList.remove('u-scroll-disabled');
      }

      function initFilterSidebar() {
        const drawer = document.querySelector(DRAWER_SELECTOR);

        if (!drawer || drawer.dataset.filterSidebarInitialized === 'true') {
          return;
        }

        drawer.dataset.filterSidebarInitialized = 'true';
        prepareDesktopSidebar(drawer);

        drawer.addEventListener('on:modal:opening', () => {
          document.body.classList.add(BODY_CLASS);
          prepareDesktopSidebar(drawer);
        });

        // Modal open adds u-scroll-disabled after the opening event.
        drawer.addEventListener('on:modal:opened', () => {
          unlockPageScroll();
        });

        drawer.addEventListener('on:modal:closed', () => {
          document.body.classList.remove(BODY_CLASS);
        });

        const section = drawer.closest('.section');
        const customCloseButton = section?.querySelector(
          '.collection-main__filter-close'
        );

        customCloseButton?.addEventListener('click', (event) => {
          event.preventDefault();
          drawer.close();
        });

        if (drawer.shown) {
          document.body.classList.add(BODY_CLASS);
          unlockPageScroll();
        }

        if (isDesktop()) {
          requestAnimationFrame(() => {
            if (!drawer.isConnected || !isDesktop() || drawer.shown) {
              unlockPageScroll();
              return;
            }

            prepareDesktopSidebar(drawer);
            drawer.open();
          });
        }
      }

      function start() {
        customElements.whenDefined('filters-dialog').then(() => {
          initFilterSidebar();
        });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start, { once: true });
      } else {
        start();
      }
    })();
